/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./demand-list.vue?vue&type=template&id=0b72b5d5&scoped=true&"
import script from "./demand-list.vue?vue&type=script&lang=js&"
export * from "./demand-list.vue?vue&type=script&lang=js&"
import style0 from "./demand-list.vue?vue&type=style&index=0&id=0b72b5d5&prod&lang=scss&scoped=true&"
import style1 from "./demand-list.vue?vue&type=style&index=1&id=0b72b5d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72b5d5",
  null
  
)

export default component.exports